import { connect } from 'react-redux';
import React, { useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';

import { setSortOption } from '../../../../../actions/searchActions';

import style from './styles.module.css';
import { ChevronRightIcon } from '../../../../../assets/icons/ChevronRight.icon';

const OrderPlanDropdown = ({ sortOptions, sort_option, setSortOption }) => {
  const [isOpened, setIsOpened] = useState(false);
  const buttonRef = useRef(null);

  const handleToggle = () => {
    setIsOpened(!isOpened);
  };

  const selectedSortOptionObj = sortOptions.find((sort) => sort.name === sort_option);
  const selectedSortOption = selectedSortOptionObj ? selectedSortOptionObj.displayName : '';

  return (
    <div className={style.filterDropdown} data-cy="filtro-ordenar">
      <button ref={buttonRef} className={style.btnFilter} onClick={handleToggle}>
        <span>
          <span>{selectedSortOption}</span>
        </span>
        <ChevronRightIcon size={24} rotate={isOpened ? 270 : 90} />
      </button>
      {isOpened && (
        <div className={style.dropdownMenu} onClick={handleToggle}>
          {sortOptions.map((option, index) => (
            <button
              key={index}
              className={`${style.dropdownItem} ${option.name === sort_option ? style.active : ''}`}
              onClick={() => setSortOption(option.name)}
            >
              {option.displayName}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default withRouter(
  connect(
    (state) => ({
      sortOptions: state.search.sortOptions,
      sort_option: state.search.sort_option,
      searchState: state.search.searchState,
    }),
    {
      setSortOption,
    }
  )(OrderPlanDropdown)
);



// WEBPACK FOOTER //
// ./src/views/v2/search/components/orderPlanDropdown/index.jsx